import { CameraChannel } from '../Interfaces/CameraChannel';
import { defineStore } from 'pinia';
import Websocket_exam from '../Pages/Exams/Exam/websocket';
import { QuestionOption } from '../Interfaces/QuestionOption';
import { usePage } from '@inertiajs/vue3';

var biometryStarted: boolean = false;
var photoStarted: boolean = false;

export const commonStore = defineStore('common', {
	state: () => ({
		ws: <string>'',
		ws_subtenant: <string>'',
		current_path_name: <unknown>window.location.pathname,
		list_camera_dvr: <Array<object>>[{}],
		computer_id: <number>0,
		option_checked: <number>0,
		question_options: <Array<QuestionOption>>[{}],
		current_question: <number>0,
	}),
	getters: {
		get_list_camera_dvr(): Array<object> {
			return this.list_camera_dvr;
		},
		get_computer_id(): number {
			return this.computer_id;
		},
		get_option_checked(): number {
			return this.option_checked;
		},
		get_question_options(): Array<QuestionOption> {
			return this.question_options;
		},
	},
	actions: {
		set_current_path_name(path_name) {
			return (this.current_path_name = path_name);
		},
		set_list_camera_dvr(list: Array<CameraChannel>) {
			list.sort((a, b) => a.channel_id - b.channel_id);
			this.list_camera_dvr = list;
		},
		set_computer_id(computer_id: number) {
			this.computer_id = computer_id;
		},
		set_option_checked(option_checked: number): number {
			return (this.option_checked = option_checked);
		},
		set_question_options(question_options: Array<QuestionOption>) {
			this.question_options = question_options;
		},
		connect_ws(ws_url) {
			new Websocket_exam(ws_url).connectWs();
		},
		haveCameraOffline() {
			var cameras = this.get_list_camera_dvr;
			var camerasOffline = cameras.filter(
				(camera) => !camera['status_ready']
			);

			return camerasOffline.length > 1;
		},
		startKeyUp() {
			this.set_current_path_name(window.location.pathname);
			document.addEventListener('keyup', this.key_Up);
		},

		eventShortcut() {
			const currentPath = this.current_path_name as string;

			// Prova (tela de questões) - suporta /prova/v2 (legado) e /prova/v3 (novo)
			if (/^\/prova\/v(2|3)(\/\d+)?$/.test(currentPath)) {
				if (
					document.getElementsByClassName('validate_question')
						.length > 0
				) {
					document.getElementById('validate')?.click();
				}
				return;
			}

			switch (currentPath) {
				case '/prova/identidade':
				case '/prova/v3/identidade':
					document.getElementById('continue')?.click();
					break;

				case '/prova/instrucoes':
				case '/prova/v3/instrucoes':
					document.getElementById('continue')?.click();
					break;

				case '/prova/liberacao-prova':
				case '/prova/v3/liberacao-prova':
					document.getElementById('confirm-button')?.click();
					break;

				case '/prova/biometria':
				case '/prova/v3/biometria':
					if (!biometryStarted) {
						document.getElementById('start-biometry')?.click();
						biometryStarted = true;
					} else {
						document.getElementById('submit-biometry')?.click();
					}
					break;

				case '/prova/foto':
				case '/prova/v3/foto':
					if (!photoStarted) {
						document.getElementById('btn-capture-photo')?.click();
						photoStarted = true;
					} else {
						document.getElementById('submit-photo')?.click();
					}
					break;

				case '/prova/digital-signature':
					if (!photoStarted) {
						document.getElementById('btn-capture-photo')?.click();
						photoStarted = true;
					} else {
						document.getElementById('submit-photo')?.click();
					}
					break;

				case '/prova/verificacao-identidade':
				case '/prova/v3/verificacao-identidade':
					document.getElementById('submit-start-prodesp')?.click();
					break;
			}
		},

		key_Up(event) {
			switch (event.keyCode) {
				case 65: // lETRA A
					this.set_option_checked(this.question_options[0].id);
					break;

				case 66: // lETRA B
					this.set_option_checked(this.question_options[1].id);
					break;

				case 67: // lETRA C
					this.set_option_checked(this.question_options[2].id);
					break;

				case 68: // lETRA D
					this.set_option_checked(this.question_options[3].id);
					break;

				case 37: // ArrowLeft
					document.getElementById('previous')?.click();
					break;

				case 39: // ArrowRight
					document.getElementById('next')?.click();
					break;

				// ENTER e HOME - UTILIZADOS PARA INICIO DA CAPTURA DE BIOMETRIA E FOTO, BEM COMO PARA AVANÇAR PARA A PRÓXIMA ETAPA
				case 13:
				case 36:
					this.eventShortcut();
					break;

				case 35: // END - UTILIZADO PARA DAR RESTART NAS AÇÕES CASO NECESSÁRIO OU LOGOUT NA TELA DE INDENTIDADE
					switch (this.current_path_name) {
						case '/prova/identidade':
						case '/prova/v3/identidade':
							document.getElementById('go-out')?.click();
							break;

						case '/prova/biometria':
						case '/prova/v3/biometria':
							document
								.getElementById('submit-restart-process')
								?.click();
							break;
						case '/prova/foto':
						case '/prova/v3/foto':
							document
								.getElementById('btn-tryagain-photo')
								?.click();
							break;

						case '/prova/digital-signature':
							document
								.getElementById('btn-tryagain-photo')
								?.click();
							break;

						case '/prova/verificacao-identidade':
						case '/prova/v3/verificacao-identidade':
							document
								.getElementById('submit-restart-process')
								?.click();
							break;

						default:
							break;
					}
					break;

				case 46: // DEL - UTILIZADA PARA LIMPAR A SELEÇÃO DA RESPOSTA
					this.set_option_checked(0);
					break;
			}
		},
	},
});
